import Bus from '@/assets/js/bus.js';
import { mapState } from 'vuex';
export default {
  props: {
    tabName: {
      type: String,
      default: '2'
    }
  },
  data() {
    return {
      showTitleShadow: false,
      loading: false,
      tipsImg: require('@/assets/img/audioMatrix.png')
    };
  },
  computed: {
    ...mapState({
      State: state => state
    }),
    refreshTips() {
      return this.State.haveUnReadMessage ? this.$t('setting.changeParticipants') : this.$t('remainWords.refresh');
    },
    screenTips() {
      return this.State.audioMatrixFullScreen ? this.$t('setting.minimize') : this.$t('setting.maximize');
    }
  },
  created() {
    Bus.$on('showTitleShadow', value => {
      this.showTitleShadow = value;
    });
    Bus.$on('changeLoading', () => {
      this.loading = false;
    });
  },
  methods: {
    closeSettingDialog() {
      this.State.audioMatrixFullScreen = false;
      this.$emit('callback');
      if (this.tabName === '3') {
        Bus.$emit('initMainWindow');
      } else if (this.tabName === '5') {
        Bus.$emit('cancelListen');
      }
    },
    controlAduioMatrixScreen(val) {
      this.State.audioMatrixFullScreen = val;
    },
    updateTable() {
      this.loading = true;
      this.State.haveUnReadMessage = false;
      Bus.$emit('getAllParticipantInfo', 'notNeedJudge');
    }
  },
  beforeDestroy() {
    Bus.$off('showTitleShadow');
  }
};